import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { useEventTracker } from '@applyboard/ui-utils';
import useInitialProps from "../../../hooks/useInitialProps";
import ModalWrapper from "../../SchoolModals/ModalWrapper";
import RequirementsTable from "./RequirementsTable";
import Filter from "./Filter";
import AsyncButton from "../../core/button/AsyncButton";
import SimpleButton from "../../core/button/SimpleButton";
import { _ModalHeaderWrapper, _BottomSubmissionWrapper, _RequirementTableWrapper, SELECTED_REQUIREMENT_CLASS_NAME } from "./style";
var SelectRequirementModal = function SelectRequirementModal(_ref) {
  var activeOnly = _ref.activeOnly,
    closeModal = _ref.closeModal,
    filters = _ref.filters,
    handleConfirm = _ref.handleConfirm,
    isRequirementIdSelected = _ref.isRequirementIdSelected,
    selectedRequirements = _ref.selectedRequirements,
    selectRequirement = _ref.selectRequirement,
    _ref$initialPageNumbe = _ref.initialPageNumber,
    initialPageNumber = _ref$initialPageNumbe === void 0 ? 0 : _ref$initialPageNumbe,
    _ref$initialPageSize = _ref.initialPageSize,
    initialPageSize = _ref$initialPageSize === void 0 ? 20 : _ref$initialPageSize,
    _ref$initialSortedBy = _ref.initialSortedBy,
    initialSortedBy = _ref$initialSortedBy === void 0 ? [{
      id: 'id',
      desc: false
    }] : _ref$initialSortedBy;
  var _useState = useState(initialPageNumber),
    _useState2 = _slicedToArray(_useState, 2),
    pageNumber = _useState2[0],
    setPageNumber = _useState2[1];
  var _useState3 = useState(initialPageSize),
    _useState4 = _slicedToArray(_useState3, 2),
    pageSize = _useState4[0],
    setPageSize = _useState4[1];
  var _useState5 = useState(initialSortedBy),
    _useState6 = _slicedToArray(_useState5, 2),
    sortingBy = _useState6[0],
    setSortingBy = _useState6[1];
  var _useInitialProps = useInitialProps(),
    userRole = _useInitialProps.role;
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  return /*#__PURE__*/React.createElement(ModalWrapper, {
    onRequestClose: closeModal,
    overflow: "hidden",
    padding: "0px",
    maxHeight: "100%"
  }, /*#__PURE__*/React.createElement(_ModalHeaderWrapper, null, /*#__PURE__*/React.createElement("span", {
    role: "heading"
  }, "Select Requirement")), /*#__PURE__*/React.createElement(Filter, null), /*#__PURE__*/React.createElement(_RequirementTableWrapper, null, /*#__PURE__*/React.createElement(RequirementsTable, {
    activeOnly: activeOnly,
    filters: filters,
    update: selectedRequirements,
    isSelected: isRequirementIdSelected,
    toggleSelection: selectRequirement,
    selectedRowClassName: SELECTED_REQUIREMENT_CLASS_NAME,
    pageNumber: pageNumber,
    pageSize: pageSize,
    sortingBy: sortingBy,
    onPageChange: setPageNumber,
    onPageSizeChange: function onPageSizeChange(selectedPageSize, currPageNumber) {
      setPageSize(selectedPageSize);
      setPageNumber(currPageNumber);
    },
    onSortedChange: setSortingBy
  })), /*#__PURE__*/React.createElement(_BottomSubmissionWrapper, null, /*#__PURE__*/React.createElement(SimpleButton, {
    buttonColor: "grey",
    buttonHeight: "40px",
    buttonHover: "hoverGrey",
    buttonWidth: "100px",
    onClick: closeModal
  }, "Cancel"), /*#__PURE__*/React.createElement(AsyncButton, {
    onClick: function onClick() {
      handleConfirm();
      trackEvent({
        event: 'Single Application - Applicant Requirements - Added Requirements To Application',
        data: {
          userRole: userRole,
          newRequirements: processSelectedRequirementEventData(selectedRequirements)
        }
      });
    },
    buttonHeight: "40px",
    buttonWidth: "100px",
    disabled: Object.keys(selectedRequirements).length === 0
  }, "Confirm")));
};
function processSelectedRequirementEventData(selectedRequirements) {
  return Object.keys(selectedRequirements).map(function (key) {
    return {
      requirementType: selectedRequirements[key].attributes.requirement_template_type,
      requirementCategory: selectedRequirements[key].attributes.requirement_category,
      requirementTemplateId: parseInt(selectedRequirements[key].id, 10),
      applicationStage: selectedRequirements[key].attributes.application_stage
    };
  });
}
export default SelectRequirementModal;